import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik } from "formik";
import Menubar from "../Menubar";
import { store } from "../../App";
import MasterService from "../../Services/MasterService";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import {
  Container,
  Row,
  Col,
  Nav,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { FaRegFile, FaUserCheck, FaRegSave } from "react-icons/fa";
import autoTable from "jspdf-autotable";
import KpiService from "../../Services/KpiService";
import {
  allowNumberswithMaxLengthcatidtypeOnly,
  allowNumberswithMaxLengthtypeOnly,
  convertFormattedToPlainNumber,
  currentDate,
  denomallowNumberswithMaxLengthtypeOnly,
  exportTokpientryExcel,
  formatNumberIndianWithDecimal,
  isFY2025OrLater,
} from "../utils/commonFunctions";
import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert";

export default function KpiIndicatorEntryMandalapprove() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [showModal, setShowModal] = useState(false);
  const [distEnb, setDistEnb] = useState(false);
  const [mandalenb, setMandalenb] = useState(false);
  const [distlist, setDistlist] = useState();
  const [mandalList, setMandalList] = useState();
  const [yearlist, setYearlist] = useState();
  const [categorylist, setCategorylist] = useState();
  const [workFlow, setWorkFlow] = useState([]);
  const [currentstatus, setCurrentstatus] = useState("");
  const [Id, setId] = useState();
  const [Periodicid, setperiodicId] = useState();
  const [entrydata, setEntrydata] = useState();
  const [entrydataEnb, setEntrydataEnb] = useState(false);
  const [sequenceId, setSequenceId] = useState();
  const [roleeid, setRoleeid] = useState();
  const [addModal, setAddModal] = useState();
  const [mandalId, setMandalId] = useState();
  const [distId, setDistId] = useState();
  const [searchText, setSearchText] = useState("");
  const [cpoTableenb, setCpoTableenb] = useState(false);
  const [Cpodata, setCpodata] = useState([]);
  const [fieldenb, setFieldenb] = useState(false);
  const [statusId, setStatusId] = useState();
  const [multiapproveenb, setMultiapproveenb] = useState(false);
  const [data, setData] = useState();
  let username = localStorage.getItem("username");
  let roleid = localStorage.getItem("role");
  let district = localStorage.getItem("districtid");
  let mandal = localStorage.getItem("mandalid");
  let deptId = localStorage.getItem("deptid");
  let deptName = localStorage.getItem("deptName");
  let ulbcode = localStorage.getItem("ulbid");
  let ulbdeptlist = JSON.parse(localStorage.getItem("ulbdeptlist") || "[]");

  const [showRemarksConfirm, setShowRemarksConfirm] = useState(false);
  const [missingRemarkNames, setMissingRemarkNames] = useState([]);

  const restrictToPasteOnlyEightDotThreeAllowKeyPress = (
    formik,
    mandal,
    fieldName,
    index,
  ) => ({
    onPaste: (e) => {
      e.preventDefault();
      const pasted = e.clipboardData.getData("text").trim();
      const regex = /^\d{1,8}(\.\d{1,3})?$/;
      if (regex.test(pasted)) {
        formik.setFieldValue(
          `mandalIndicatorsData[${index}].entries.${mandal}.${fieldName}`,
          pasted,
        );
      } else {
        showAlertMessage(
          "Only numbers with up to 8 digits before the decimal point and up to 3 digits after the decimal point are allowed. ",
          "warning",
        );
      }
    },
  });

  const restrictToPasteEightDotThreeHandler = (
    formik,
    mandal,
    fieldName,
    index,
    isAllowedNegative,
    unit_cat_id,
  ) => ({
    onPaste: (e) => {
      e.preventDefault();
      const pasted = e.clipboardData.getData("text").trim();
      if (pasted === "-") {
        showAlertMessage(
          "Please enter a valid number, not just '-'.",
          "warning",
        );
        return;
      }
      if (unit_cat_id !== 1 && pasted.includes(",")) {
        showAlertMessage("Commas are not allowed in this field.", "warning");
        return;
      }

      const cleanValue = pasted.replace(/,/g, "");
      const numericValue = parseFloat(cleanValue);
      const isNumeric = !isNaN(numericValue);
      const baseRegex = /^-?\d{1,8}(\.\d{1,3})?$/;
      const rule = `${isAllowedNegative}`.trim();
      if (!baseRegex.test(cleanValue)) {
        showAlertMessage(
          "Only numbers with up to 8 digits before and 3 digits after the decimal point are allowed.",
          "warning",
        );
        return;
      }

      if (isNumeric) {
        switch (rule) {
          case "1":
            if (numericValue <= 0) {
              showAlertMessage("Only positive numbers are allowed.", "warning");
              return;
            }
            break;
          case "0":
            if (numericValue < 0) {
              showAlertMessage("Negative numbers are not allowed.", "warning");
              return;
            }
            break;
          case "-1":
            break;
          case "null":
            showAlertMessage("Only positive numbers are allowed.", "warning");
            break;
          default:
            showAlertMessage(
              "Invalid configuration for number restrictions.",
              "warning",
            );
            return;
        }
      }
      formik.setFieldValue(
        `mandalIndicatorsData[${index}].entries.${mandal}.${fieldName}`,
        pasted,
      );
    },
  });

  const formik = useFormik({
    initialValues: {
      userId: "",
      district_id: "",
      department_id: "",
      mandal_id: "",
      periodic_id: "",
      category: "",
      year: "",
      date: "",
      mandalIndicatorsData: [],
      Indicators: [
        {
          indicator_id: "",
          entry_value: "",
          numerator: "",
          denominator: "",
          multiplir: "",
          columns: "",
          maxLength: "",
          type: "",

          unit: "",
          status_id: "",
          ind_type: "",
          ind_phase: "",
          consolidatedRemarks: "",
        },
      ],

      remarks: "",
    },
    onSubmit: (values) => { },
  });
  const handleClose = () => {
    setAddModal(false);
  };
  const handleClosepop = () => {
    setShowModal(false);
  };
  React.useEffect(() => {
    if (roleid === "32" || roleid === "2") {
      setMandalenb(false);
      setDistEnb(true);
    }
    if (roleid === "60" || roleid === "5") {
      setDistEnb(false);
    }
    if (roleid === "31" || roleid === "3" || roleid === "10") {
      setDistEnb(true);
      setMandalenb(true);
    }

    formik.setFieldValue("district_id", district !== "0" ? district : "");

    let params = { district_id: district };
    MasterService.getMandals(params).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.id}>
              {" "}
              {item.value}{" "}
            </option>
          );
        });
        setMandalList(options);
      }
    });
    formik.setFieldValue(
      "mandal_id",
      mandal !== "0" && mandal !== "00" ? mandal : "",
    );
  }, []);

  const [selectedMandals, setSelectedMandals] = useState([]);

  const handleCheckboxChange = (e, mandalName) => {
    console.log(
      "formik.values.periodic_id",
      formik.values.periodic_id,
      formik.values.year,
      formik.values.category,
    );

    const checked = e.target.checked;
    setSelectedMandals((prev) =>
      checked
        ? [...new Set([...prev, mandalName])]
        : prev.filter((item) => item !== mandalName),
    );
  };

  const normalize = (str) => str?.toLowerCase().replace(/[^a-z0-9]/gi, "");

  const buildPayload = () => {
    const indicaterEntryDto = [];

    const mandalMetaMap = {};
    selectedMandals.forEach((mandalName) => {
      const normSelected = normalize(mandalName);
      let meta = [];
      if (ulbdeptlist.includes(deptId)) {
        meta = Cpodata.find(
          (item) =>
            normalize(item.ulb_name) === normSelected &&
            item.sequence_id !== null,
        );
      } else {
        meta = Cpodata.find(
          (item) =>
            normalize(item.mandal_name) === normSelected &&
            item.sequence_id !== null,
        );
      }
      if (meta) {
        mandalMetaMap[normSelected] = meta;
      }
    });

    let num = false;
    let den = false;
    formik.values.mandalIndicatorsData.forEach((indicator) => {
      const indicatorId = indicator.indicator_id;
      console.log("REMARK CHECK:", {
        indicatorId,
        ind_phase: indicator.ind_phase,
        remarks: indicator.consolidatedRemarks,
      });
      Object.entries(indicator.entries).forEach(([mandalkey, entry]) => {
        const normKey = normalize(mandalkey);
        if (selectedMandals.some((d) => normalize(d) === normKey)) {
          const mandalMeta = mandalMetaMap[normKey];
          if (entry?.numerator && !entry?.denominator) {
            den = true;
          }
          if (!entry?.numerator && entry?.denominator) {
            num = true;
          }
          if (mandalMeta && entry.entry_value) {
            indicaterEntryDto.push({
              district_id: mandalMeta.district_id,
              mandal_id: ulbdeptlist.includes(deptId)
                ? "0"
                : mandalMeta.mandal_code,
              ulbId: ulbdeptlist.includes(deptId) ? mandalMeta.ulb_code : "0",
              sequence_id: mandalMeta.sequence_id,
              indicatorType: entry.ind_type,
              indicator_id: indicatorId,
              unit: mandalMeta.unit,
              status_id: entry.status_id,
              indicator_value:
                indicator.unit_cat_id === 13
                  ? entry.entry_value
                  : convertFormattedToPlainNumber(entry.entry_value) || "",
              numerator: entry.numerator || "0",
              denominator: entry.denominator || "0",
              consolidatedApproverRemark:
                Number(indicator.ind_phase) === 4
                  ? (indicator.consolidatedRemarks ?? "")
                  : "",
              makerRemarks: entry.maker_remarks ?? "",
            });
          }
        }
      });
    });

    const finalPayload = {
      type: multiapproveenb ? "multiApprove" : "multiUpdate",
      userId: username,
      dept_id: roleid === "8" ? formik.values.department_id : deptId,
      status_id: multiapproveenb ? 4 : 2,
      newIndicatorsStatus: multiapproveenb ? 4 : 2,
      role_id: multiapproveenb ? 200 : 32,
      periodicity_id: formik.values.periodic_id,
      ...(multiapproveenb ? { remarks: formik.values.remarks } : {}),
      year: formik.values.year,
      head_id: formik.values.category ? formik.values.category : "0",
      indicaterEntryDto,
    };

    return { num, den, finalPayload };
  };

  const Emptyfields = () => {
    formik.setFieldValue("year", "");
    formik.setFieldValue("category", "");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === "Escape") {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const [deptlist, setDeptlist] = useState([]);
  const [activePeriodicity, setActivePeriodicity] = useState(""); // or default like "1" const [data, setData] = useState(null);
  const periodicityMap = {
    monthly: { label: "MONTHLY", value: "6" },
    quarterly: { label: "QUARTERLY", value: "7" },
    half_yearly: { label: "HALFYEARLY", value: "5" },
    annually: { label: "ANNUALLY", value: "3" },
    bi_annual: { label: "BIENNIAL", value: "8" },
    five_years: { label: "FIVE-YEARS", value: "2" },
  };

  useEffect(() => {
    store.dispatch({ type: "SHOW_SPINNER" });
    if (roleid !== "8") {
      let paramss = {
        userId: username,
        deptId: deptId,
        mandal: "Yes",
        district: "No",
        state: "No",
        secretariat: "No",
      };
      KpiService.getperiodicityStatusForAchievementsEntry(paramss).then(
        (res) => {
          if (res.data.SCODE === "01") {
            setData(res.data.SDESC[0]);
            setPeriodiclistenb(true);
          } else {
            showAlertMessage(res.data.SDESC, "warning");
            setPeriodiclistenb(false);
          }
        },
      );
    }
    MasterService.getDistricts().then((res17) => {
      if (res17.data) {
        let options = res17.data.map((item, i) => {
          return (
            <option key={i} value={item.id}>
              {" "}
              {item.value}{" "}
            </option>
          );
        });
        setDistlist(options);
      }
    });
    if (roleid === "8") {
      let paramss = { userId: username };
      MasterService.getDeptartments(paramss).then((res) => {
        if (res.data) {
          let options = res.data?.SDESC.map((item, i) => {
            return (
              <option key={i} value={item.dept_id}>
                {" "}
                {item.dept_name}{" "}
              </option>
            );
          });
          setDeptlist(options);
        }
      });
    }

    store.dispatch({ type: "HIDE_SPINNER" });
  }, []);

  useEffect(() => {
    const updatedValues = { ...formik.values };
    let hasChanges = false;

    updatedValues.mandalIndicatorsData.forEach((indicator, i) => {
      Object.entries(indicator.entries).forEach(([mandalName, entry]) => {
        const numerator = parseFloat(entry.numerator);
        const denominator = parseFloat(entry.denominator);
        const no_of_columns = parseFloat(entry.no_of_columns);
        const multiplier = parseFloat(entry.multiplir);
        const divider = parseFloat(entry.devider);
        let formatted = "";

        if (no_of_columns === 3) {
          const isValid =
            !isNaN(numerator) && !isNaN(denominator) && denominator !== 0;
          if (denominator == "0") {
            formatted = "0.000";
          }
          if (isValid) {
            const calculated = multiplier
              ? (numerator / denominator) * multiplier
              : multiplier == "" && divider
                ? numerator / denominator / divider
                : numerator / denominator;
            formatted = calculated.toFixed(3);
          }
          if (entry.entry_value !== formatted) {
            updatedValues.mandalIndicatorsData[i].entries[
              mandalName
            ].entry_value = formatted;
            hasChanges = true;
          }
        }

        if (no_of_columns === 4) {
          const isValid =
            !isNaN(numerator) && !isNaN(denominator) && denominator !== 0;
          if (denominator == "0") {
            formatted = "0";
          }
          if (isValid) {
            const calculated = multiplier
              ? ((numerator - denominator) / denominator) * multiplier
              : multiplier == "" && divider
                ? (numerator - denominator) / denominator / divider
                : numerator / denominator;
            formatted = calculated.toFixed(3);
          }
          if (entry.entry_value !== formatted) {
            updatedValues.mandalIndicatorsData[i].entries[
              mandalName
            ].entry_value = formatted;
            hasChanges = true;
          }
        }
      });
    });

    if (hasChanges) {
      formik.setValues(updatedValues);
    }
  }, [
    JSON.stringify(
      formik.values.mandalIndicatorsData.map((indicator) =>
        Object.values(indicator.entries).map((e) => [
          e.numerator,
          e.denominator,
          e.multiplir,
          e.devider,
        ]),
      ),
    ),
  ]);

  const Categorydata = (e) => {
    setCategorylist([]);

    formik.setFieldValue("category", "");
    formik.setFieldValue("date", "");

    if (!e.target.value) {
      let missingFields = [];
      if (roleid === "8") {
        if (!formik.values.district_id) missingFields.push("District");
        if (!formik.values.mandal_id) missingFields.push("Mandal");
      }
      if (formik.values.periodic_id) missingFields.push("Periodicity");
      if (!e.target.value) missingFields.push("Year");
      const errorMessage = `Please Select Required Field ${missingFields.join(", ")}.`;
      showAlertMessage(errorMessage, "warning");
      setEntrydataEnb(false);
      setCpoTableenb(false);
      return;
    }
    const selectedYear = e.target.value;
    setId(selectedYear);

    if (["1", "2", "3", "8"].includes(Periodicid)) {
      if (roleid === "8") {
        console.log("roleid 8");
      }
      if (!["31", "3"].includes(roleid)) {
        let paramss = {
          userId: username,
          districtId: !["32", "2"].includes(roleid)
            ? formik.values.district_id
            : district,
          periodicityId: formik.values.periodic_id,
          year: e.target.value,
          deptId: roleid === "8" ? formik.values.department_id : deptId,
          headId: "0",
        };
        CountData(paramss, e.target.value);
      } else {
        const params = {
          userId: username,
          districtId:
            roleid === "60" || roleid === "5" || roleid === "8"
              ? distId
              : district,
          mandalId: ulbdeptlist.includes(deptId) ? "0" : mandalId,
          ulbId: ulbdeptlist.includes(deptId) ? ulbcode : "0",
          year: e.target.value,
          headId: "0",
          deptId: roleid === "8" ? formik.values.department_id : deptId,
          periodicityId: formik.values.periodic_id,
        };

        fetchEntryData(params);
      }
    } else {
      const params = {
        userId: username,
        periodicityId: Periodicid,
        year: e.target.value,
      };
      KpiService.kpiperiodicityMasterFutureDatesExtension(params).then(
        (res) => {
          const response = res.data.SDESC.headList;
          const options = response.map((item, i) => (
            <option key={i} value={item.id}>
              {" "}
              {item.value}{" "}
            </option>
          ));
          setCategorylist(options);
        },
      );
    }
  };
  const YearData = (e) => {
    formik.setFieldValue("year", "");
    formik.setFieldValue("date", "");
    formik.setFieldValue("category", "");
    setEntrydataEnb(false);
    setCpoTableenb(false);
    if (!e.target.value) {
      return;
    }
    setCategorylist([]);

    setperiodicId(e.target.value);
    setId("");

    let params = { userId: username, periodicityId: e.target.value };
    KpiService.KpiperiodicYears(params).then((res20) => {
      let years = res20.data?.SDESC?.yearsList || [];
      // let res = res20.data?.SDESC?.headList === null  && e.target.value !== "8" ? years.slice(1) : years;
      let res = years;
      if (res20.data) {
        let options = res.map((item, i) => {
          return (
            <option key={i} value={item.id}>
              {" "}
              {item.value}{" "}
            </option>
          );
        });
        setYearlist(options);
      }
    });
    setYearlist([]);
    setEntrydataEnb(false);
  };

  const [uniqueMandals, setUniqueMandals] = useState();
  const [buttonenb, setButtonenb] = useState(false);
  const CountData = (params, year) => {
    formik.setFieldValue("mandalIndicatorsData", []);
    setSelectedMandals([]);
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.CpoTableData(params)
      .then((res) => {
        if (res.data.SCODE === "01") {
          if (
            res.data.mandalWiseIndicatorsEntryProgressReportDataStatus.length >
            0
          ) {
            const data =
              res.data.mandalWiseIndicatorsEntryProgressReportDataStatus;
            setCpodata(data);
            setCpoTableenb(true);
            setEntrydataEnb(false);
            let uniqueMandals = [];
            if (ulbdeptlist.includes(deptId)) {
              uniqueMandals = [
                ...new Set(data.map((item) => item.ulb_name).filter(Boolean)),
              ];
            } else {
              uniqueMandals = [
                ...new Set(
                  data.map((item) => item.mandal_name).filter(Boolean),
                ),
              ];
            }
            console.log(uniqueMandals);
            setUniqueMandals(uniqueMandals);
            let enb = false;

            const districtStatusMap = {};
            data.forEach((item) => {
              const district = ulbdeptlist.includes(deptId)
                ? item.ulb_code
                : item.mandal_code;
              if (!districtStatusMap[district]) {
                districtStatusMap[district] = [];
              }
              districtStatusMap[district].push(item.status_id);
            });
            for (const district in districtStatusMap) {
              const statuses = districtStatusMap[district];

              if (statuses.some((status_id) => status_id == 2)) {
                enb = true;
                break;
              }
            }
            if (enb) {
              setButtonenb(true);
            } else {
              setButtonenb(false);
            }

            const indicatorsMap = {};

            data.forEach((item) => {
              const unit_name = item.unit_name;
              const indicatorId = item.indicator_id;

              const mandalName = ulbdeptlist.includes(deptId)
                ? item.ulb_name
                : item.mandal_name;
              if (!indicatorsMap[indicatorId]) {
                indicatorsMap[indicatorId] = {
                  unit_name: unit_name,
                  indicator_id: indicatorId,
                  indicator_name: item.indicator_name || indicatorId,
                  ind_type: item.ind_type,
                  ind_phase: item.ind_phase,
                  consolidatedRemarks: item.consolidated_approver_remark ?? "",
                  entries: {},
                };
              }
              // Map Remarks uniquely based on indicator_id
              if (
                Number(item.ind_phase) === 4 &&
                item.consolidated_approver_remark != null &&
                item.consolidated_approver_remark !== ""
              ) {
                indicatorsMap[indicatorId].consolidatedRemarks =
                  item.consolidated_approver_remark;
              }

              indicatorsMap[indicatorId].entries[normalize(mandalName)] = {
                numerator: item.numerator || "",
                denominator: item.denominator || "",
                entry_value: item.indicator_value || "",
                status: item.status || "Not Yet Forwarded",
                no_of_columns: item.no_of_columns || "",
                sequence_id: item.sequence_id || "",
                district_id: item.district_id || "",
                mandal_code: item.mandal_code || "",
                ulb_code: item.ulb_code || "",
                unit_cat_id: item.unit_cat_id || "",
                unit: item.unit || "",
                indicator_id: item.indicator_id || "",
                max_length: item.max_length || "",
                unit_name: item.unit_name || "",
                indicator_name: item.indicator_name || "",
                multiplir: item.multiplir || "",
                devider: item.devider || "",
                is_zero: item.iszero,
                targets_2025: item.targets_2025,
                status_id: item.status_id,
                ind_type: item.ind_type,
                ind_phase: item.ind_phase,
                targetenb:
                  isFY2025OrLater(year) && item.targets_2025 === null
                    ? true
                    : false,
                consolidatedRemarks: item.consolidated_approver_remark ?? "",
                maker_remarks: item.maker_remarks ?? "",
              };
            });

            const mandalIndicatorsData = Object.values(indicatorsMap);
            formik.setValues((prevValues) => ({
              ...prevValues,
              mandalIndicatorsData,
            }));
          } else {
            setCpodata([]);
            setCpoTableenb(false);
            showAlertMessage("No Data Found!", "warning");
          }
        } else {
          setCpoTableenb(false);
          setCpodata([]);
          showAlertMessage(res.data.SDESC, "warning");
        }
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  // const hasOldStatus = formik.values.mandalIndicatorsData.some((indicator) =>
  //   mandallist.some((mandal) => {
  //     const entry = indicator.entries?.[normalize(mandal)];
  //     return entry && [4].includes(entry.status_id);
  //   })
  // );

  const getEntrydata = (e) => {
    if (!e.target.value) {
      let missingFields = [];
      if (!e.target.value) missingFields.push("Category");
      const errorMessage = `Please Select Required Field ${missingFields.join(", ")}.`;
      showAlertMessage(errorMessage, "warning");
      setCpoTableenb(false);
      setEntrydataEnb(false);
      return;
    }
    if (!["31", "3"].includes(roleid)) {
      let paramss = {
        userId: username,
        districtId: !["32", "2"].includes(roleid)
          ? formik.values.district_id
          : district,
        periodicityId: formik.values.periodic_id,
        year: formik.values.year,
        headId: e.target.value,
        deptId: roleid === "8" ? formik.values.department_id : deptId,
      };
      CountData(paramss, formik.values.year);
    } else {
      const params = {
        userId: username,
        districtId:
          roleid === "60" || roleid === "5" || roleid === "8"
            ? formik.values.district_id
            : district,
        mandalId: ulbdeptlist.includes(deptId) ? "0" : formik.values.mandal_id,
        ulbId: ulbdeptlist.includes(deptId) ? ulbcode : "0",
        year: formik.values.year,
        headId: e.target.value,
        deptId: roleid === "8" ? formik.values.department_id : deptId,
        periodicityId: formik.values.periodic_id,
      };
      fetchEntryData(params);
    }
  };

  const fetchEntryData = (params) => {
    formik.setFieldValue("Indicators", []);
    setSequenceId(null);
    if (roleid === "32" || roleid === "2") {
      setCpoTableenb(true);
      setEntrydataEnb(false);
    }
    if (
      roleid === "31" ||
      roleid === "60" ||
      roleid === "3" ||
      roleid === "5" ||
      roleid === "8"
    ) {
      setCurrentstatus("");
      setWorkFlow([]);

      store.dispatch({ type: "SHOW_SPINNER" });
      KpiService.Kpientrydata(params)
        .then((res) => {
          if (res.data.SCODE === "01") {
            setEntrydataEnb(true);
            setCpoTableenb(false);

            setEntrydata(res.data.SDESC);
            setCurrentstatus(res.data.WorkFlowCurrentStatus[0]?.status || "");
            setWorkFlow(res.data.getWorkFlow || []);
            res.data.SDESC.forEach((item, i) => {
              formik.setFieldValue(
                `Indicators[${i}].entry_value`,
                (() => {
                  const raw = item.indicator_value;
                  if (raw == null || raw === "") return "";
                  if (isNaN(raw)) return raw;
                  const num = +raw;
                  return Number.isInteger(num)
                    ? num
                    : Math.floor(num * 1000) / 1000;
                })(),
              );
              formik.setFieldValue(
                `Indicators[${i}].indicator_id`,
                item.indicator_id === null ? "" : item.indicator_id,
              );
              formik.setFieldValue(
                `Indicators[${i}].columns`,
                item.no_of_columns === null ? "" : item.no_of_columns,
              );
              formik.setFieldValue(
                `Indicators[${i}].maxLength`,
                item.max_length === null ? "" : item.max_length,
              );
              formik.setFieldValue(
                `Indicators[${i}].type`,
                item.rec_type === null ? "" : item.rec_type,
              );
              formik.setFieldValue(
                `Indicators[${i}].unit`,
                item.unit === null ? "" : item.unit,
              );
              formik.setFieldValue(
                `Indicators[${i}].numerator`,
                item.numerator === null ? "" : item.numerator,
              );
              formik.setFieldValue(
                `Indicators[${i}].denominator`,
                item.denominator === null ? "" : item.denominator,
              );
              formik.setFieldValue(
                `Indicators[${i}].multiplir`,
                item.multiplir,
              );
              formik.setFieldValue(
                `Indicators[${i}].devider`,
                item.devider === null ? "" : item.devider,
              );
              formik.setFieldValue(`Indicators[${i}].ind_type`, item.ind_type);
              formik.setFieldValue(
                `Indicators[${i}].ind_phase`,
                item.ind_phase,
              );
              formik.setFieldValue(
                `Indicators[${i}].status_id`,
                item.status_id,
              );
              formik.setFieldValue(
                `Indicators[${i}].targets_2025`,
                item.targets_2025 === null ? "" : item.targets_2025,
              );
              console.log("item.sequence_id ", i, item.sequence_id);
              if (item.sequence_id !== null) {
                setSequenceId(item.sequence_id);
              }
            });
          } else {
            setEntrydata([]);
            setEntrydataEnb(false);
            showAlertMessage(res.data.SDESC, "warning");
          }
          if (
            Array.isArray(res.data.statusCheck) &&
            res.data.statusCheck.length > 0
          ) {
            setStatusId(res.data.statusCheck[0]?.status_id);
            setRoleeid(res.data.statusCheck[0]?.role_id);
          } else {
            setRoleeid(31);
            setStatusId("0");
          }

          setFieldenb(
            (roleid === "31" || roleid === "3") &&
              (res.data.statusCheck[0]?.role_id === 200 ||
                res.data.statusCheck[0]?.role_id === 32 ||
                res.data.statusCheck[0]?.role_id === 2 ||
                res.data.statusCheck[0]?.role_id === 60)
              ? true
              : (roleid === "32" || roleid === "2") &&
                (res.data.statusCheck[0]?.role_id === 31 ||
                  res.data.statusCheck[0]?.role_id === 3 ||
                  res.data.statusCheck[0]?.role_id === 200 ||
                  res.data.statusCheck[0]?.role_id === 60)
                ? true
                : roleid === "8" && res.data.statusCheck[0]?.role_id === 200
                  ? true
                  : false,
          );
        })
        .finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
        });
    }
  };

  const filteredData =
    searchText.length > 0 && Cpodata?.length
      ? Cpodata.filter((item) => {
        return (
          item &&
          Object.keys(item).some((key) => {
            const value = item[key];
            return (
              value !== null &&
              value
                .toString()
                .toLowerCase()
                .includes(searchText.toLowerCase())
            );
          })
        );
      })
      : Cpodata;

  const filteredMandals = uniqueMandals?.filter((mandal) =>
    filteredData?.some((item) =>
      ulbdeptlist.includes(deptId)
        ? item.ulb_name === mandal
        : item.mandal_name === mandal,
    ),
  );

  const districtHasmaker_remarks = (districtname) =>
    Cpodata.some((item) =>
      ulbdeptlist.includes(deptId)
        ? item.ulb_name === districtname
        : item.mandal_name === districtname && Number(item.ind_phase) === 4,
    );

  const handleInputChange = (e, index, mandal, field, isZero) => {
    const rawValue = e.target.value.trim();

    // Block if just a minus sign is entered
    if (rawValue === "-") {
      showAlertMessage(
        "Please enter a valid number, not just '-'.",
        "warning",

        () => {
          formik.setFieldValue(
            `mandalIndicatorsData[${index}].entries.${mandal}.${field}`,
            "",
          );
        },
      );
      return;
    }

    const sanitizedValue = rawValue.replace(/,/g, "");
    const numericValue = parseFloat(sanitizedValue);

    const isZeroRule = parseInt(isZero); // Convert once to number
    // const isDenominator = field === "numerator" || field === "denominator";

    if (!isNaN(numericValue)) {
      // Denominator-specific rules

      if (numericValue <= 0 && ![0, -1].includes(isZeroRule)) {
        showAlertMessage(
          "Denominator must be a positive number",
          "warning",
          () => {
            formik.setFieldValue(
              `mandalIndicatorsData[${index}].entries.${mandal}.${field}`,
              "",
            );
          },
        );
        return;
      }

      if (numericValue === 0 && isZeroRule === 1) {
        console.log(isZero);
        showAlertMessage(
          "Only positive numbers are allowed for this indicator",
          "warning",
          () => {
            formik.setFieldValue(
              `mandalIndicatorsData[${index}].entries.${mandal}.${field}`,
              "",
            );
          },
        );
        return;
      }

      if (numericValue === 0 && ![0, -1].includes(isZeroRule)) {
        showAlertMessage(
          "Zero is not allowed for this indicator",
          "warning",
          () => {
            formik.setFieldValue(
              `mandalIndicatorsData[${index}].entries.${mandal}.${field}`,
              "",
            );
          },
        );
        return;
      }

      if (numericValue < 0 && isZeroRule !== -1) {
        showAlertMessage(
          "Negative values are not allowed for this indicator",
          "warning",
          () => {
            formik.setFieldValue(
              `mandalIndicatorsData[${index}].entries.${mandal}.${field}`,
              "",
            );
          },
        );
        return;
      }
    }

    // All validations passed
    formik.setFieldValue(`Indicators[${index}].${field}`, rawValue);
  };

  const denominatorchange = (index, mandal, unit_cat_id) => {
    if (
      formik.values.mandalIndicatorsData[index].entries[mandal].entry_value >
      parseFloat(100) &&
      [2, 9, 11].includes(unit_cat_id)
    ) {
      showAlertMessage(
        "Achieved Value Exceeded 100%. Kindly check it.",
        "warning",
      );
    }
  };

  const checkVal = () => {
    if (!formik.values.remarks) {
      let missingFields = [];
      if (!formik.values.remarks) missingFields.push("Remarks");
      const errorMessage = "Please Enter Remarks";
      showAlertMessage(errorMessage, "warning");
      return;
    }
    setMultiapproveenb(true);

    setAddModal(false);
    setShowModal(true);
  };

  const getDistrictApprovalSummary = () => {
    const isUlb = ulbdeptlist.includes(deptId);
    const map = {};

    Cpodata.forEach((item) => {
      const name = isUlb ? item.ulb_name : item.mandal_name;
      if (!name) return;
      if (!map[name]) map[name] = [];
      map[name].push(item.status_id);
    });

    const allMandals = Object.keys(map);
    const total = allMandals.length;
    console.log("mandalscount", total);
    const approvedMandals = allMandals.filter((m) =>
      map[m].every((s) => Number(s) === 4),
    );

    const selectedCount = selectedMandals.filter(
      (m) => map[m] && !approvedMandals.includes(m),
    ).length;

    const remainingNotSelected = allMandals.filter(
      (m) => !approvedMandals.includes(m) && !selectedMandals.includes(m),
    ).length;

    const isFinalApproval = selectedCount + approvedMandals.length === total;
    return {
      total,
      selectedCount,
      approvedCount: approvedMandals.length,
      remainingNotSelected,
      isFinalApproval,
    };
  };
  const getIndicatorsMissingRemarks = () =>
    formik.values.mandalIndicatorsData
      .map((ind, idx) => ({ ind, slNo: idx + 1 }))
      .filter(
        ({ ind }) =>
          Number(ind.ind_phase) === 4 &&
          !(ind.consolidatedRemarks ?? "").toString().trim(),
      )
      .map(({ ind, slNo }) => `${slNo}. ${ind.indicator_name}`);

  const savemultientry = () => {
    if (selectedMandals.length === 0) {
      showAlertMessage(
        `Please Select Any One ${ulbdeptlist.includes(deptId) ? "ULB" : "Mandal"} to Update... `,
        "warning",
      );
      return;
    }
    // const payload = buildPayload();
    const { num, den, finalPayload } = buildPayload();
    if (num) {
      showAlertMessage(`Please Enter Numerator!`, "warning");
      return;
    }
    if (den) {
      showAlertMessage(`Please Enter Denominator!`, "warning");
      return;
    }

    // console.log("payload", payload);
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.mandalLevelIndicatorsDataEntrySave(finalPayload)
      .then((res) => {
        showAlertMessage(
          res.data.SDESC,
          res.data.SCODE === "01" ? "success" : "warning",
          () => {
            setSelectedMandals([]);
            setShowModal(false);
            if (res.data.SCODE === "01") {
              let params = {
                userId: username,
                districtId: !["32", "2"].includes(roleid)
                  ? formik.values.district_id
                  : district,
                periodicityId: formik.values.periodic_id,
                year: formik.values.year,
                deptId: roleid === "8" ? formik.values.department_id : deptId,
                headId: formik.values.category ? formik.values.category : "0",
              };
              CountData(params, formik.values.year);
            }
          },
        );
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };
  const MultiApproveData = () => {
    setShowModal(false);
    // const payload = buildPayload();
    const { num, den, finalPayload } = buildPayload();
    if (num) {
      showAlertMessage(`Please Enter Numerator!`, "warning");
      return;
    }
    if (den) {
      showAlertMessage(`Please Enter Denominator!`, "warning");
      return;
    }
    store.dispatch({ type: "SHOW_SPINNER" });

    KpiService.mandalLevelIndicatorsDataEntrySave(finalPayload)
      .then((res) => {
        showAlertMessage(
          res.data.SDESC,
          res.data.SCODE === "01" ? "success" : "warning",
          () => {
            setMultiapproveenb(false);
            if (res.data.SCODE === "01") {
              let params = {
                userId: username,
                districtId: !["32", "2"].includes(roleid)
                  ? formik.values.district_id
                  : district,
                periodicityId: formik.values.periodic_id,
                year: formik.values.year,
                deptId: roleid === "8" ? formik.values.department_id : deptId,
                headId: formik.values.category ? formik.values.category : "0",
              };
              CountData(params, formik.values.year);
            }
          },
        );
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const ForwardHodmultipop = () => {
    formik.setFieldValue("remarks", "");
    if (selectedMandals.length === 0) {
      showAlertMessage(
        `Please Select Any One ${ulbdeptlist.includes(deptId) ? "ULB" : "Mandal"} to approve... `,
        "warning",
      );
      return;
    }
    const incompleteMandals = [];

    selectedMandals.forEach((mandalName) => {
      let hasMissingEntries = false;

      formik.values.mandalIndicatorsData.forEach((indicator) => {
        const entry = indicator.entries[normalize(mandalName)];

        if (entry) {
          const hasTarget =
            entry.targets_2025 !== null && entry.targets_2025 !== "";
          const noEntry =
            entry.entry_value === null || entry.entry_value === "";

          if (hasTarget && noEntry) {
            hasMissingEntries = true;
          }
        }
      });

      if (hasMissingEntries) {
        incompleteMandals.push(mandalName);
      }
    });

    if (incompleteMandals.length > 0) {
      showAlertMessage(
        `Please enter values for all indicators which have targets assigned in the following ${ulbdeptlist.includes(deptId) ? "ULB(s)" : "Mandal(s)"}: ${incompleteMandals.join(", ")}.`,
        "warning",
      );
      return;
    }
    // ---- consolidated remarks validation ----
    const { isFinalApproval, remainingNotSelected } =
      getDistrictApprovalSummary();
    const missing = getIndicatorsMissingRemarks();

    if (missing.length > 0) {
      if (isFinalApproval) {
        showAlertMessage(
          `Consolidated Remarks must be entered for the following indicator(s): ${missing.join("; ")}`,
          "warning",
        );
        return;
      }

      // Case 2: some district (status !== 4) is not selected -> warn, let user decide
      if (remainingNotSelected > 0) {
        setMissingRemarkNames(missing);
        setShowRemarksConfirm(true);
        return;
      }
    }

    //  let enable = validatefieldvalues(); if (enable) { return; }
    setAddModal(true);
  };

  useEffect(() => {
    if (data) {
      const firstKey = Object.entries(periodicityMap).find(
        ([key]) => data?.[key] > 0,
      );
      if (firstKey) {
        const { value } = firstKey[1];
        setActivePeriodicity(value);

        const syntheticEvent = {
          target: { name: "periodic_id", value },
        };

        YearData(syntheticEvent);
        formik.handleChange(syntheticEvent);
      }
    }
  }, [data]);
  const [periodiclistenb, setPeriodiclistenb] = useState(false);

  const perioicitylist = (e) => {
    formik.setFieldValue("mandal_id", "");
    formik.setFieldValue("district_id", "");
    setPeriodiclistenb(false);
    setEntrydataEnb(false);
    setCpoTableenb(false);
    let paramss = {
      userId: username,
      deptId: e.target.value,
      mandal: "Yes",
      district: "No",
      state: "No",
      secretariat: "No",
    };
    KpiService.getperiodicityStatusForAchievementsEntry(paramss).then((res) => {
      if (res.data) {
        if (res.data.SCODE === "01") {
          setData(res.data.SDESC[0]);
          setPeriodiclistenb(true);
        } else {
          showAlertMessage(res.data.SDESC, "warning");
          setPeriodiclistenb(false);
          setEntrydataEnb(false);
        }
      }
    });
  };

  return (
    <>
      <Menubar />

      <Container fluid style={{ width: "95%" }} className="map-header">
        {" "}
        <div className="sa-title">
          {" "}
          <h2>
            {" "}
            Indicator{" "}
            <span>
              {" "}
              Entry - {ulbdeptlist.includes(deptId) ? "ULB" : "Mandal"}{" "}
              Level{" "}
            </span>{" "}
          </h2>{" "}
        </div>{" "}
      </Container>

      <Container
        fluid
        style={{ width: "95%" }}
        className="outer-page-content-container mt-3"
      >
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container p-4">
              <Row>
                {roleid !== "8" && (
                  <Col
                    xs={12}
                    sm={12}
                    lg={3}
                    md={3}
                    xl={3}
                    xxl={3}
                    className="district-select"
                  >
                    <label className="mb-1 fw-bold">Secretariat Name</label>
                    <Field
                      className="mb-3 form-control"
                      type="text"
                      name="dept_name"
                      value={localStorage.getItem("SectariatcodeName")}
                      controlId="formBasicEmail"
                      disabled={true}
                      style={{ fontWeight: "bold" }}
                    ></Field>
                  </Col>
                )}
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                  {" "}
                  <label className="mb-1 fw-bold"> HOD Name</label>
                  {roleid === "8" ? (
                    <Field
                      component="select"
                      name="department_id"
                      className="mb-3 form-control"
                      onChange={(e) => {
                        Emptyfields();
                        formik.handleChange(e);
                        perioicitylist(e);
                      }}
                      style={{ fontWeight: "bold" }}
                      disabled={
                        deptId === "179" || roleid === "8" ? false : true
                      }
                    >
                      <option value="">--Select--</option> {deptlist}{" "}
                    </Field>
                  ) : (
                    <Field
                      className="mb-3 form-control"
                      type="text"
                      name="dept_name"
                      value={localStorage.getItem("deptcodeName")}
                      controlId="formBasicEmail"
                      disabled={true}
                      style={{ fontWeight: "bold" }}
                    ></Field>
                  )}
                </Col>

                <Col
                  xs={12}
                  sm={12}
                  lg={3}
                  md={3}
                  xl={3}
                  xxl={3}
                  className="district-select"
                >
                  <label className="mb-1 fw-bold">District</label>
                  <Field
                    className="mb-3 form-control"
                    component="select"
                    name="district_id"
                    onChange={(e) => {
                      setDistId(e.target.value);
                      Emptyfields();
                      formik.handleChange(e);
                    }}
                    controlId="formBasicEmail"
                    disabled={distEnb}
                    style={{ fontWeight: "bold" }}
                  >
                    {" "}
                    <option value="">--Select--</option> {distlist}{" "}
                  </Field>
                </Col>
              </Row>
            </div>

            {periodiclistenb && (
              <>
                <div className="tabs-top">
                  <Nav
                    variant="pills"
                    className="tabs-row d-flex flex-wrap justify-content-start gap-1 mb-2 mt-4"
                  >
                    {Object.entries(periodicityMap)
                      .filter(([key]) => data?.[key] > 0)
                      .map(([key, { label, value }]) => (
                        <div
                          key={key}
                          className="flex-grow-1 flex-shrink-0"
                          style={{ maxWidth: "120px" }}
                        >
                          <Nav.Item className="tab-boxes-small">
                            <Nav.Link
                              eventKey={value}
                              onClick={() => {
                                const syntheticEvent = {
                                  target: { name: "periodic_id", value },
                                };
                                setActivePeriodicity(value);
                                YearData(syntheticEvent);
                                formik.handleChange(syntheticEvent);
                                formik.setFieldValue(
                                  "mandalIndicatorsData",
                                  [],
                                );
                              }}
                              active={activePeriodicity === value}
                              className="text-center"
                            >
                              <p className="text-truncate text-center m-0">
                                {label}
                              </p>
                            </Nav.Link>
                          </Nav.Item>
                        </div>
                      ))}
                  </Nav>
                </div>

                <Row>
                  <Col
                    xs={12}
                    sm={12}
                    lg={3}
                    md={3}
                    xl={3}
                    xxl={3}
                    className="mandal-select "
                    style={{ marginLeft: "15px" }}
                  >
                    <label className="mb-1 fw-bold">Year</label>
                    <Field
                      className="mb-3 form-control"
                      component="select"
                      name="year"
                      controlId="formBasicEmail"
                      onChange={(e) => {
                        Categorydata(e);
                        formik.handleChange(e);
                      }}
                      style={{ fontWeight: "bold" }}
                    >
                      {" "}
                      <option value="">--Select--</option> {yearlist}{" "}
                    </Field>
                  </Col>

                  {(Periodicid === "5" ||
                    Periodicid === "6" ||
                    Periodicid === "7") && (
                      <Col
                        xs={12}
                        sm={12}
                        lg={3}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mandal-select"
                      >
                        <label className="mb-1 fw-bold">Category</label>
                        <Field
                          className="mb-3 form-control"
                          component="select"
                          name="category"
                          controlId="formBasicEmail"
                          style={{ fontWeight: "bold" }}
                          onChange={(e) => {
                            getEntrydata(e);
                            formik.handleChange(e);
                          }}
                        >
                          {" "}
                          <option value="">--Select--</option> {categorylist}{" "}
                        </Field>
                      </Col>
                    )}

                  {Periodicid === "4" && (
                    <Col
                      xs={12}
                      sm={12}
                      lg={3}
                      md={3}
                      xl={3}
                      xxl={3}
                      className="mandal-select"
                    >
                      {" "}
                      <label className="mb-1 fw-bold">Date</label>{" "}
                      <Field
                        className="mb-3 form-control"
                        type="date"
                        name="date"
                        onChange={(e) => {
                          getEntrydata(e);
                          formik.handleChange(e);
                        }}
                        max={currentDate}
                        controlId="formBasicEmail"
                        style={{ fontWeight: "bold" }}
                      />{" "}
                    </Col>
                  )}
                </Row>
              </>
            )}

            {cpoTableenb && (
              <>
                <Row className="mt-3">
                  <Col
                    xxl={12}
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className=""
                  >
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={3}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className=" mb-3"
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "20px",
                            border: "1px solid #ddd",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            transition: "all 0.3s ease-in-out",
                            backgroundColor: "#fff",
                            padding: "5px 10px",
                            width: "150px",
                            minWidth: "150px",
                          }}
                          onFocus={(e) => {
                            e.currentTarget.style.boxShadow =
                              "0 6px 12px rgba(0, 0, 0, 0.2)";
                            e.currentTarget.style.border = "1px solid #353935";
                            e.currentTarget.style.width = "100%";
                          }}
                          onBlur={(e) => {
                            e.currentTarget.style.boxShadow =
                              "0 4px 8px rgba(0, 0, 0, 0.1)";
                            e.currentTarget.style.border = "1px solid #ddd";
                            e.currentTarget.style.width = "150px";
                          }}
                        >
                          <AiOutlineSearch
                            className="me-2"
                            style={{
                              fontSize: "1.2rem",
                              color: "#888",
                              visibility: "visible",
                            }}
                          />{" "}
                          <input
                            type="text"
                            placeholder="Search "
                            value={searchText}
                            onChange={(event) =>
                              setSearchText(event.target.value)
                            }
                            style={{
                              flex: "1",
                              border: "none",
                              outline: "none",
                              fontSize: "1rem",
                              color: "#333",
                              backgroundColor: "transparent",
                              transition: "color 0.3s ease",
                              minWidth: "0",
                            }}
                          />
                        </div>
                      </Col>

                      <Col className=" mb-2 ">
                        {" "}
                        <button
                          variant="success"
                          size="sm"
                          className="btn mx-2 excel-btn"
                          style={{
                            float: "right",
                            color: "#ffffff",
                            marginLeft: "3px",
                          }}
                          onClick={() =>
                            exportTokpientryExcel(
                              "my-table1",
                              formik.values,
                              "MandalLevelKPIIndicatorReport",
                            )
                          }
                        >
                          {" "}
                          Excel
                          <AiFillFileExcel style={{ fontSize: "18px" }} />{" "}
                        </button>{" "}
                      </Col>
                    </Row>
                    <div className="kp-indicatortable ">
                      <div
                        id="table-scroll"
                        className="table-scroll table-wrap mt-2 mb-5"
                      >
                        <table
                          className="table table-bordered custom-table table-responsive sticky-table"
                          id="my-table1"
                        >
                          <thead style={{ borderRadius: "10px 10px 0px 0px" }}>
                            <tr className="text-center">
                              <th rowSpan={2} className="sticky-col sticky-sno">
                                Sl.No.
                              </th>
                              <th
                                rowSpan={2}
                                className="sticky-col sticky-INDICATOR indicator-cell"
                              >
                                Indicator
                              </th>
                              <th
                                rowSpan={2}
                                className="sticky-col sticky-UNIT unit-column"
                              >
                                {" "}
                                Unit{" "}
                              </th>
                              {formik.values.mandalIndicatorsData?.some(
                                (item) => Number(item.ind_phase) === 4,
                              ) && (
                                  <th
                                    rowSpan={2}
                                    className="sticky-col sticky-Remarks"
                                  >
                                    Consolidated Remarks
                                  </th>
                                )}

                              {filteredMandals.map((mandalName, idx) => {
                                const mandalRecords = Cpodata.filter((item) =>
                                  ulbdeptlist.includes(deptId)
                                    ? item.ulb_name === mandalName
                                    : item.mandal_name === mandalName,
                                );

                                const allApproved =
                                  mandalRecords.length > 0 &&
                                  mandalRecords.every(
                                    (item) => item.status_id == 4,
                                  );
                                const hasAtLeastOneStarted = mandalRecords.some(
                                  (item) => item.status_id == 2,
                                );

                                const showCheckbox =
                                  !allApproved && hasAtLeastOneStarted;

                                return (
                                  <th
                                    key={idx}
                                    colSpan={
                                      isFY2025OrLater(formik.values.year)
                                        ? 3
                                        : 2
                                    }
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "5px",
                                      }}
                                    >
                                      <span>{mandalName}</span>
                                      {showCheckbox && (
                                        <label className="custom-checkbox">
                                          <input
                                            type="checkbox"
                                            checked={selectedMandals.includes(
                                              mandalName,
                                            )}
                                            onChange={(e) =>
                                              handleCheckboxChange(
                                                e,
                                                mandalName,
                                              )
                                            }
                                          />
                                          <span className="checkmark"></span>
                                        </label>
                                      )}
                                    </div>
                                  </th>
                                );
                              })}
                            </tr>

                            <tr className="text-center">
                              {filteredMandals?.map((_, idx) => (
                                <React.Fragment key={idx}>
                                  <th>Numerator/Denominator</th>
                                  <th>Achieved Value</th>

                                  {isFY2025OrLater(formik.values.year) && (
                                    <th>
                                      Targets
                                      <br />({formik.values.year})
                                    </th>
                                  )}
                                </React.Fragment>
                              ))}
                            </tr>
                          </thead>

                          <tbody>
                            {(() => {
                              const mandalsWithAllNotStarted = {};
                              const mandalsWithFirstRowRendered = {};
                              const mandalsWithStartedIndicators = {};
                              const mandalsWithApproved = {};
                              const hasOldStatusByMandal = {};
                              const hasForwardByMandal = {};
                              filteredMandals.forEach((mandalName) => {
                                const mandal = normalize(mandalName);

                                mandalsWithApproved[mandalName] =
                                  formik.values.mandalIndicatorsData.some(
                                    (indicator) => {
                                      const entry = indicator.entries?.[mandal];
                                      return entry?.status_id == 4;
                                    },
                                  );

                                mandalsWithStartedIndicators[mandalName] =
                                  formik.values.mandalIndicatorsData.some(
                                    (indicator) => {
                                      const entry = indicator.entries?.[mandal];
                                      const hasUserInput =
                                        entry?.numerator ||
                                        entry?.denominator ||
                                        entry?.entry_value;
                                      return (
                                        entry &&
                                        (![0, null].includes(entry.status_id) ||
                                          hasUserInput)
                                      );
                                    },
                                  );

                                mandalsWithAllNotStarted[mandal] =
                                  formik.values.mandalIndicatorsData.every(
                                    (indicator) => {
                                      const entry = indicator.entries?.[mandal];
                                      const noUserInput =
                                        !entry?.numerator &&
                                        !entry?.denominator &&
                                        !entry?.entry_value;
                                      return (
                                        (!entry ||
                                          [0, null].includes(
                                            entry.status_id,
                                          )) &&
                                        noUserInput
                                      );
                                    },
                                  );

                                hasOldStatusByMandal[mandalName] =
                                  formik.values.mandalIndicatorsData.some(
                                    (indicator) => {
                                      const entry = indicator.entries?.[mandal];
                                      return entry && entry.status_id === 4;
                                    },
                                  );

                                hasForwardByMandal[mandalName] =
                                  formik.values.mandalIndicatorsData.some(
                                    (indicator) => {
                                      const entry = indicator.entries?.[mandal];
                                      return entry && entry.status_id === 2;
                                    },
                                  );
                              });

                              return formik.values.mandalIndicatorsData.map(
                                (indicator, i) => (
                                  <tr key={indicator.indicator_id}>
                                    <td
                                      className="sticky-col sticky-sno"
                                      style={{ textAlign: "center" }}
                                    >
                                      {i + 1}
                                    </td>
                                    <td className="sticky-col sticky-INDICATOR indicator-column">
                                      {indicator.ind_type === "N" && (
                                        <img
                                          src="../images/new3.gif"
                                          width="20px"
                                          alt="new"
                                          style={{ marginRight: "5px" }}
                                        />
                                      )}
                                      {indicator.indicator_name}
                                    </td>
                                    <td
                                      style={{ textAlign: "left" }}
                                      className="sticky-col sticky-UNIT unit-column"
                                    >
                                      {indicator.unit_name}
                                    </td>
                                    {formik.values.mandalIndicatorsData?.some(
                                      (item) => Number(item.ind_phase) === 4,
                                    ) && (
                                        <td className="sticky-col sticky-Remarks">
                                          {Number(indicator.ind_phase) === 4 && (
                                            <Field
                                              as="textarea"
                                              name={`mandalIndicatorsData[${i}].consolidatedRemarks`}
                                              value={
                                                formik.values
                                                  .mandalIndicatorsData[i]
                                                  ?.consolidatedRemarks ?? ""
                                              }
                                              onChange={(e) => {
                                                formik.setFieldValue(
                                                  `mandalIndicatorsData[${i}].consolidatedRemarks`,
                                                  e.target.value,
                                                );
                                              }}
                                              className="form-control"
                                              rows={2}
                                              placeholder="Enter Remarks"
                                              disabled={!buttonenb}
                                            />
                                          )}
                                        </td>
                                      )}
                                    {filteredMandals.map((mandalName) => {
                                      const mandal = normalize(mandalName);
                                      const entry = indicator.entries?.[mandal];

                                      // const isDisabled = mandalsWithApproved[mandalName];

                                      const oldStatusDisabled =
                                        entry?.ind_type === "O" &&
                                        hasOldStatusByMandal[mandalName];

                                      if (mandalsWithAllNotStarted[mandal]) {
                                        if (
                                          mandalsWithFirstRowRendered[mandal]
                                        ) {
                                          return null;
                                        } else {
                                          mandalsWithFirstRowRendered[mandal] =
                                            true;
                                          return (
                                            <td
                                              key={mandal}
                                              colSpan={
                                                isFY2025OrLater(
                                                  formik.values.year,
                                                )
                                                  ? 3
                                                  : 2
                                              }
                                              rowSpan={
                                                formik.values
                                                  .mandalIndicatorsData.length
                                              }
                                              style={{
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                              }}
                                            >
                                              Not Yet Forwarded
                                            </td>
                                          );
                                        }
                                      } else {
                                        const hasUserInput =
                                          entry?.numerator ||
                                          entry?.denominator ||
                                          entry?.entry_value;

                                        const shouldShowFields =
                                          mandalsWithStartedIndicators[
                                          mandalName
                                          ] ||
                                          (entry && entry.status_id == 4) ||
                                          hasUserInput;
                                        return (
                                          <React.Fragment key={mandal}>
                                            {shouldShowFields ? (
                                              <>
                                                {entry?.no_of_columns === 3 ? (
                                                  <td className="text-right text-end">
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "5px",
                                                      }}
                                                    >
                                                      <Field
                                                        autoComplete="off"
                                                        name={`mandalIndicatorsData[${i}].entries.${mandal}.numerator`}
                                                        disabled={
                                                          [4].includes(
                                                            entry?.status_id,
                                                          ) ||
                                                          (!hasForwardByMandal[
                                                            mandalName
                                                          ] &&
                                                            [
                                                              null,
                                                              "",
                                                              0,
                                                            ].includes(
                                                              entry?.status_id,
                                                            )) ||
                                                          oldStatusDisabled ||
                                                          entry?.targetenb
                                                        }
                                                        // disabled={formik.values.mandalIndicatorsData[i].entries[mandal].status_id==="4"|| isDisabled||entry?.targetenb}
                                                        className="form-control"
                                                        onBlur={(e) => {
                                                          handleInputChange(
                                                            e,
                                                            i,
                                                            mandal,
                                                            "numerator",
                                                            entry?.is_zero,
                                                          );
                                                          denominatorchange(
                                                            i,
                                                            mandal,
                                                            entry.unit_cat_id,
                                                          );
                                                          formik.handleChange(
                                                            e,
                                                          );
                                                        }}
                                                        type="text"
                                                        {...restrictToPasteEightDotThreeHandler(
                                                          formik,
                                                          mandal,
                                                          "numerator",
                                                          i,
                                                          entry?.is_zero,
                                                          entry?.unit_cat_id,
                                                        )}
                                                        onInput={(e) =>
                                                          allowNumberswithMaxLengthtypeOnly(
                                                            e,
                                                            entry?.max_length,
                                                            "numeric",
                                                            3,
                                                            entry?.is_zero,
                                                          )
                                                        }
                                                        style={{
                                                          textAlign: "right",
                                                        }}
                                                      />
                                                      <span
                                                        style={{
                                                          fontSize: "15px",
                                                        }}
                                                      >
                                                        /
                                                      </span>
                                                      <Field
                                                        autoComplete="off"
                                                        name={`mandalIndicatorsData[${i}].entries.${mandal}.denominator`}
                                                        className="form-control"
                                                        disabled={
                                                          [4].includes(
                                                            entry?.status_id,
                                                          ) ||
                                                          (!hasForwardByMandal[
                                                            mandalName
                                                          ] &&
                                                            [
                                                              null,
                                                              "",
                                                              0,
                                                            ].includes(
                                                              entry?.status_id,
                                                            )) ||
                                                          oldStatusDisabled ||
                                                          entry?.targetenb
                                                        }
                                                        // disabled={isDisabled|| entry?.targetenb}
                                                        {...restrictToPasteOnlyEightDotThreeAllowKeyPress(
                                                          formik,
                                                          mandal,
                                                          "denominator",
                                                          i,
                                                        )}
                                                        onBlur={(e) => {
                                                          handleInputChange(
                                                            e,
                                                            i,
                                                            mandal,
                                                            "denominator",
                                                            entry?.is_zero,
                                                          );
                                                          denominatorchange(
                                                            i,
                                                            mandal,
                                                            entry.unit_cat_id,
                                                          );
                                                          formik.handleChange(
                                                            e,
                                                          );
                                                        }}
                                                        type="text"
                                                        onInput={(e) => {
                                                          denomallowNumberswithMaxLengthtypeOnly(
                                                            e,
                                                            entry?.max_length,
                                                            "numeric",
                                                            3,
                                                          );
                                                        }}
                                                        //onKeyPress={(e) => allowNumberswithMaxLengthtypeOnly(e, entry?.max_length, "numeric", 3,entry?.is_zero)}
                                                        style={{
                                                          textAlign: "right",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>
                                                ) : (
                                                  <td></td>
                                                )}

                                                <td className="text-right text-end">
                                                  <div className="d-flex align-items-center">
                                                    {entry.unit_cat_id !==
                                                      13 ? (
                                                      <Field
                                                        autoComplete="off"
                                                        className="form-control"
                                                        name={`mandalIndicatorsData[${i}].entries.${mandal}.entry_value`}
                                                        value={
                                                          entry.unit_cat_id ===
                                                            1
                                                            ? formatNumberIndianWithDecimal(
                                                              formik.values
                                                                .mandalIndicatorsData[
                                                                i
                                                              ].entries[
                                                                mandal
                                                              ].entry_value,
                                                            )
                                                            : formik.values
                                                              .mandalIndicatorsData[
                                                              i
                                                            ].entries[mandal]
                                                              .entry_value
                                                        }
                                                        disabled={
                                                          [4].includes(
                                                            entry?.status_id,
                                                          ) ||
                                                          (!hasForwardByMandal[
                                                            mandalName
                                                          ] &&
                                                            [
                                                              null,
                                                              "",
                                                              0,
                                                            ].includes(
                                                              entry?.status_id,
                                                            )) ||
                                                          oldStatusDisabled ||
                                                          entry?.no_of_columns ===
                                                          3 ||
                                                          entry?.targetenb
                                                        }
                                                        // disabled={isDisabled || entry?.no_of_columns === 3|| entry?.targetenb}
                                                        onBlur={(e) => {
                                                          handleInputChange(
                                                            e,
                                                            i,
                                                            mandal,
                                                            "entry_value",
                                                            entry?.is_zero,
                                                          );
                                                          formik.handleChange(
                                                            e,
                                                          );
                                                        }}
                                                        onInput={(e) => {
                                                          if (
                                                            entry.unit_cat_id ===
                                                            1
                                                          ) {
                                                            allowNumberswithMaxLengthcatidtypeOnly(
                                                              e,
                                                              entry?.max_length,
                                                              "numeric",
                                                              3,
                                                              entry?.is_zero,
                                                            );
                                                          } else {
                                                            allowNumberswithMaxLengthtypeOnly(
                                                              e,
                                                              entry?.max_length,
                                                              "numeric",
                                                              3,
                                                              entry?.is_zero,
                                                            );
                                                          }
                                                        }}
                                                        {...restrictToPasteEightDotThreeHandler(
                                                          formik,
                                                          mandal,
                                                          "entry_value",
                                                          i,
                                                          entry?.is_zero,
                                                          entry?.unit_cat_id,
                                                        )}
                                                        type="text"
                                                        style={{
                                                          textAlign: "right",
                                                        }}
                                                      />
                                                    ) : (
                                                      <Field
                                                        component="select"
                                                        name={`Indicators[${i}].entry_value`}
                                                        className="form-control mb-3"
                                                        style={{
                                                          fontWeight: "bold",
                                                        }}
                                                        disabled={
                                                          [4].includes(
                                                            entry?.status_id,
                                                          ) ||
                                                          (!hasForwardByMandal[
                                                            mandalName
                                                          ] &&
                                                            [
                                                              null,
                                                              "",
                                                              0,
                                                            ].includes(
                                                              entry?.status_id,
                                                            )) ||
                                                          oldStatusDisabled ||
                                                          entry?.no_of_columns ===
                                                          3
                                                        }
                                                      >
                                                        {" "}
                                                        <option value="">
                                                          --Select--
                                                        </option>{" "}
                                                        <option value="100">
                                                          TOP ACHIEVERS
                                                        </option>{" "}
                                                        <option value="75">
                                                          ACHIEVERS
                                                        </option>{" "}
                                                        <option value="50">
                                                          FAST MOVERS
                                                        </option>{" "}
                                                        <option value="25">
                                                          ASPIRERS
                                                        </option>{" "}
                                                      </Field>
                                                    )}
                                                  </div>
                                                </td>
                                                {isFY2025OrLater(
                                                  formik.values.year,
                                                ) && (
                                                    <td
                                                      style={{
                                                        textAlign: "right",
                                                      }}
                                                    >
                                                      {entry?.targets_2025}

                                                      {districtHasmaker_remarks(
                                                        mandalName,
                                                      ) &&
                                                        Number(
                                                          entry?.ind_phase,
                                                        ) === 4 &&
                                                        entry?.maker_remarks && (
                                                          <OverlayTrigger
                                                            placement="top"
                                                            trigger={[
                                                              "hover",
                                                              "focus",
                                                            ]}
                                                            container={
                                                              typeof document !==
                                                                "undefined"
                                                                ? document.body
                                                                : undefined
                                                            }
                                                            overlay={
                                                              <Tooltip
                                                                id={`tooltip-maker-${i}-${mandal}`}
                                                                className="custom-tooltipp"
                                                              >
                                                                <strong
                                                                  style={{
                                                                    fontSize:
                                                                      "18px",
                                                                  }}
                                                                >
                                                                  Maker
                                                                  Remarks:{" "}
                                                                </strong>
                                                                <br />
                                                                {
                                                                  entry.maker_remarks
                                                                }
                                                              </Tooltip>
                                                            }
                                                          >
                                                            <span
                                                              tabIndex={0}
                                                              style={{
                                                                cursor: "pointer",
                                                                display:
                                                                  "inline-flex",
                                                              }}
                                                            >
                                                              <img
                                                                src="images/remarks.png"
                                                                alt="info"
                                                                style={{
                                                                  width: "20px",
                                                                  height: "20px",
                                                                  marginLeft:
                                                                    "10px",
                                                                }}
                                                                className="img-fluid"
                                                              />
                                                              {/* <AiOutlineEye style={{ fontSize: "22px", color: "#0d6efd" }} /> */}
                                                            </span>
                                                          </OverlayTrigger>
                                                        )}
                                                    </td>
                                                  )}
                                              </>
                                            ) : (
                                              <td
                                                colSpan={
                                                  isFY2025OrLater(
                                                    formik.values.year,
                                                  )
                                                    ? 3
                                                    : 2
                                                }
                                                style={{ textAlign: "center" }}
                                              >
                                                Not Yet Forwaded
                                              </td>
                                            )}
                                          </React.Fragment>
                                        );
                                      }
                                    })}
                                  </tr>
                                ),
                              );
                            })()}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {buttonenb && (
                      <div className="bottom-buttons d-flex justify-content-center mt-4 mb-4">
                        {" "}
                        <Button
                          variant=""
                          size="sm"
                          className="save-btn  mx-4 mt-4"
                          onClick={() => savemultientry()}
                        >
                          {" "}
                          Update <FaRegSave className="ms-1 s-icon" />{" "}
                        </Button>{" "}
                        <Button
                          variant=""
                          size="sm"
                          className="next-btn  mx-4 mt-4"
                          onClick={() => ForwardHodmultipop()}
                        >
                          {" "}
                          Approve <FaRegSave className="ms-1 s-icon" />{" "}
                        </Button>{" "}
                      </div>
                    )}
                  </Col>{" "}
                </Row>
              </>
            )}

            <Modal
              fade={false}
              className="newmodal"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={addModal}
            >
              <Modal.Header>
                {["8", "32", "2"].includes(roleid) ? (
                  <Modal.Title
                    className="text-center  fw-bold"
                    style={{
                      margin: "0 auto",
                      color: "black",
                      fontFamily: "'Times New Roman', Times, serif",
                    }}
                  >
                    Confirm & Approve
                  </Modal.Title>
                ) : (
                  <Modal.Title
                    className="text-center  fw-bold"
                    style={{
                      margin: "0 auto",
                      color: "black",
                      fontFamily: "'Times New Roman', Times, serif",
                    }}
                  >
                    Forward To{" "}
                  </Modal.Title>
                )}
                <span
                  role="button"
                  tabIndex={0}
                  onClick={handleClose}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleClose();
                    }
                  }}
                  style={{ cursor: "pointer", color: "white" }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "red")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "white")}
                >
                  {" "}
                  &#215;{" "}
                </span>
              </Modal.Header>
              <Modal.Body className="p-5">
                <Modal.Dialog className="internal">
                  {!["60", "32", "2", "5", "8"].includes(roleid) && (
                    <Modal.Body>
                      <p className="d-flex">
                        {" "}
                        <FaUserCheck className="usericon" />
                        <Field
                          style={{
                            margin: "0 auto",
                            color: "black",
                            fontSize: "15px",
                            fontWeight: "bold",
                            fontFamily: "Arial, sans-serif",
                          }}
                          type="text"
                          value={
                            ["31", "3", "5"].includes(roleid)
                              ? `District Officer(${deptName})`
                              : ""
                          } // component="select" name="forward"
                          className="form-control"
                          disabled={true}
                        ></Field>
                      </p>
                    </Modal.Body>
                  )}
                  <Modal.Footer>
                    {" "}
                    Remarks <sup className="mandatort">*</sup>{" "}
                    <Field
                      as="textarea"
                      name="remarks"
                      rows={2}
                      cols={40}
                      style={{ resize: "none" }}
                      maxLength={200}
                    />{" "}
                  </Modal.Footer>
                </Modal.Dialog>
              </Modal.Body>
              <Modal.Footer>
                <button type="button" className="conform" onClick={checkVal}>
                  {" "}
                  Confirm <FaRegFile />
                </button>
              </Modal.Footer>
            </Modal>

            <Modal
              fade={false}
              className="newmodal"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={showModal}
              onHide={null}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header>
                {" "}
                <Modal.Title></Modal.Title>{" "}
                <span
                  role="button"
                  tabIndex={0}
                  onClick={handleClosepop}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleClosepop();
                    }
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "red")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "white")}
                  style={{ fontSize: "30px", cursor: "pointer" }}
                  className="me-1"
                >
                  {" "}
                  &#215;{" "}
                </span>{" "}
              </Modal.Header>
              <Modal.Body
                className="p-3 d-flex flex-column justify-content-center align-items-center"
                onKeyDown={handleKeyDown}
              >
                {" "}
                <div className="text-center">
                  {" "}
                  <img
                    src="images/question.gif"
                    style={{ width: "70px", marginBottom: "10px" }}
                    alt="Warning Icon"
                  />{" "}
                  <p className="fw-bold" style={{ fontSize: "17px" }}>
                    {" "}
                    Are you sure you want to{" "}
                    {roleid === "31" || roleid === "3" ? "Forward" : "Approve"}?
                    Once Submitted no further changes will be allowed.{" "}
                  </p>{" "}
                </div>{" "}
              </Modal.Body>
              <Modal.Footer>
                {["8", "32", "2"].includes(roleid) && (
                  <button
                    type="button"
                    className="conform"
                    onClick={() => {
                      MultiApproveData();
                    }}
                  >
                    {" "}
                    Yes{" "}
                  </button>
                )}
                <button
                  type="button"
                  className="cancel"
                  onClick={handleClosepop}
                >
                  {" "}
                  No{" "}
                </button>
              </Modal.Footer>
            </Modal>

            <Modal
              fade={false}
              className="newmodal"
              centered
              show={showRemarksConfirm}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header>
                {" "}
                <Modal.Title></Modal.Title>
                <button
                  type="button"
                  aria-label="Close"
                  onClick={() => setShowRemarksConfirm(false)}
                  style={{
                    fontSize: "30px",
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    lineHeight: 1,
                  }}
                  className="me-1"
                >
                  {" "}
                  &#215;{" "}
                </button>
              </Modal.Header>
              <Modal.Body
                className="p-3 d-flex flex-column justify-content-center align-items-center"
                onKeyDown={handleKeyDown}
              >
                <img
                  src="images/question.gif"
                  style={{ width: "70px", marginBottom: "10px" }}
                  alt="Warning Icon"
                />{" "}
                <p
                  className="fw-bold"
                  style={{ fontSize: "17px", textAlign: "center" }}
                >
                  {" "}
                  Consolidated Remarks should be entered for Economic
                  indicators. Do you still want to continue?{" "}
                </p>
              </Modal.Body>
              <Modal.Footer>
                {" "}
                <button
                  type="button"
                  className="conform"
                  onClick={() => {
                    setShowRemarksConfirm(false);
                    setAddModal(true);
                  }}
                >
                  {" "}
                  Yes{" "}
                </button>{" "}
                <button
                  type="button"
                  className="cancel"
                  onClick={() => setShowRemarksConfirm(false)}
                >
                  {" "}
                  No{" "}
                </button>{" "}
              </Modal.Footer>
            </Modal>
          </Form>
        </FormikProvider>
      </Container>

      <AlertModal
        show={showAlert}
        titleText={alertData.titleText}
        alertText={alertData.alertText}
        onClose={closeAlert}
      />
    </>
  );
}
